module.exports = __webpack_public_path__ + "static/media/vid-authentication-bg.e6db2c46.mp4";